﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { BpMpTemperature } from '../models/bp-mp-temperature';
import { BenchSheetSampleType, BenchSheetTechnologyType, EditType, MessageBoxReplyType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { MessageBoxReply } from '../models/message-box-reply';
//import { PWMath } from '../utilities/pw-math';

import { Button } from 'devextreme-react/button';
import Guid from 'devextreme/core/guid';

import { ReactGrid, Id, Cell, CellChange, TextCell, Column, Row, Range, DefaultCellTypes } from "@silevis/reactgrid";
import "@silevis/reactgrid/styles.css";

//needed?
const PENDING_CHANGES = 1;

const DECIMAL_PLACES = 3;
const TEMPERATURE_ID_COLUMN_IDX = 0;
const EDIT_TYPE_COLUMN_ID = "editType";

/*
const WEIGHT_1_COLUMN_ID = 7;
const WEIGHT_2_COLUMN_ID = 8;
const WEIGHT_3_COLUMN_ID = 9;
const WEIGHT_4_COLUMN_ID = 10;
*/

export interface Props {
    benchSheetId?: string;
    //needed?
    //technologyId: BenchSheetTechnologyType;
    onClose?: () => void;
}

export default function BpMpTemperatures(props: Props) {
    const [temperatures, setTemperatures] =
        useState<BpMpTemperature[]>();

    const [selectedTemperatureId, setSelectedTemperatureId] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [rows, setRows] =
        useState<Row[]>();

    const [headerRow, setHeaderRow] =
        useState<Row>();

    const [columns, setColumns] =
        useState<Column[]>();
           
    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    useEffect(() => {
        getRows();
    }, [temperatures]);

    return (
        <div>
        <div className="pw-comp-row pw-margin-top-05">
            <div className="title-bar-spacer" />
            <div className="save-toolbar pw-margin-right-05">
                <Button className="title-bar-button"
                    text="Add Row" icon="plus" type="success"
                    hint="add row"
                    onClick={onAddRowClick} />

                <Button id="saveButton" text="Save" icon="save" type="success"
                    className="pw-button"
                    hint="save changes"
                    height={'1.8rem'}
                    onClick={onSaveClick} />

                <Button id="closeButton" text="Close" icon="close" type="normal"
                    className="pw-button"
                    hint="close dialog"
                    height={'1.8rem'}
                    onClick={onCloseClick} />
            </div>
        </div>

        <div className="pw-margin-top-1">
            <ReactGrid
                enableFillHandle={true}
                enableRangeSelection={true}
                rows={rows ? rows : []} columns={columns ? columns : []}
                onSelectionChanging={onSelectionChanging}
                onColumnResized={handleColumnResize}
                onCellsChanged={handleChanges} />
        </div>
        
        {globalDialogVisible &&
            <GlobalDialog metadata={globalDialogMetadata}
                onReply={onGlobalDialogReply} onClose={onGlobalDialogClose} />
        }

    </div>
    );

    function handleColumnResize(ci: Id, width: number) {
        if (!columns)
            return;

        setColumns((prevColumns) => {
            const columnIndex = prevColumns.findIndex(el => el.columnId === ci);
            const resizedColumn = prevColumns[columnIndex];
            const updatedColumn = { ...resizedColumn, width };
            prevColumns[columnIndex] = updatedColumn;
            return [...prevColumns];
        });
    }

    function onAddRowClick() {
        let editedtemperatures = [...temperatures];

        let newTemperature: BpMpTemperature = {
            sampleName: "",
            temperatureId: new Guid().toString(),
            editType: EditType.Insert
        };

        editedtemperatures.push(newTemperature);

        setTemperatures(editedtemperatures);
    }

    function onSelectionChanging(selectedRanges: Range[]): boolean {
        console.log("onSelectionChanging");
        console.log(selectedRanges);

        if (selectedRanges && selectedRanges.length > 0 &&
            selectedRanges[0].columns && selectedRanges[0].columns.length > 0 &&
            selectedRanges[0].rows && selectedRanges[0].rows.length > 0) {

            //const rowId = selectedRanges[0].rows[0].rowId;

            const selectedTemperatureIdCell = selectedRanges[0].first.row.cells[TEMPERATURE_ID_COLUMN_IDX] as any;
            const temperatureId = selectedTemperatureIdCell.text;

            //console.log("weightDatumId:");
            //console.log(weightDatumId);

            /*
            const weight1Cell = selectedRanges[0].first.row.cells[WEIGHT_1_COLUMN_ID] as any;
            const weight1 = weight1Cell ? weight1Cell.text : 0;
            const weight2Cell = selectedRanges[0].first.row.cells[WEIGHT_2_COLUMN_ID] as any;
            const weight2 = weight2Cell ? weight2Cell.text : 0;
            const weight3Cell = selectedRanges[0].first.row.cells[WEIGHT_3_COLUMN_ID] as any;
            const weight3 = weight3Cell ? weight3Cell.text : 0;
            const weight4Cell = selectedRanges[0].first.row.cells[WEIGHT_4_COLUMN_ID] as any;
            const weight4 = weight4Cell ? weight4Cell.text : 0;
            */

            setSelectedTemperatureId(temperatureId);
        }

        return true;
    }

    function handleChanges(changes: CellChange<TextCell>[]) {

        //maybe rework this - 
        //   applyChangesToWeightData set to variable, then pass that to calculateValues
        //   then setWeightData  :-)
        if (!temperatures)
            return;

        let prevTemperatures = [...temperatures]

        let editedTemperatures = applyChangesToTemperatures(changes, prevTemperatures);

        //let calculatedWeightData = calculateValues(editedWeightData);

        setTemperatures(editedTemperatures);

        //setWeightData((prevWeightData) => applyChangesToWeightData(changes, prevWeightData));
    };

    function applyChangesToTemperatures(changes: CellChange<TextCell>[], prevTemperatures: BpMpTemperature[]): BpMpTemperature[] {
        //console.log("changes:");
        //console.log(changes);

        changes.forEach((change) => {
            const temperatureIndex = change.rowId;
            const fieldName = change.columnId;

            prevTemperatures[temperatureIndex][fieldName] = change.newCell.text;

            if (prevTemperatures[temperatureIndex].editType !== EditType.Insert)
                prevTemperatures[temperatureIndex].editType = EditType.Update;
        });

        return [...prevTemperatures];
    };

    function getRows() {
        //console.log("getRows");
        //console.log("samples...");
        //console.log(samples);



        let createdRows: Row[];

        if (!temperatures) {
            let newTemperatures: BpMpTemperature[] = [];
            newTemperatures.push({ temperatureId: new Guid().toString(), sampleName: "", editType: EditType.Insert });

            setTemperatures(newTemperatures);
        }
        else {
            //if (weightData) {
            //if (editedWeightData) {
            //let editedWeightData = [...weightData];

            //editedWeightData = calculateValues(editedWeightData);

            //setWeightData(editedWeightData);


            createdRows = [
                headerRow,
                //...weightData.map<Row<DefaultCellTypes>>((weightDatum, idx) => ({
                ...temperatures.map<Row<DefaultCellTypes>>((temperature, idx) => ({
                    rowId: idx,
                    cells: [
                        { type: "text", text: temperature ? temperature.temperatureId : "", nonEditable: true, className: "reactgrid-hidden-column" },
                        { type: "text", text: "", nonEditable: true, className: getEditTypeTemplate(temperature) },
                        { type: "text", text: temperature.sampleName ? temperature.sampleName : "", className: "reactgrid-cell" },
                        { type: "text", text: formatTemperature(temperature.tempX), className: 'reactgrid-cell' },
                        { type: "text", text: formatTemperature(temperature.tempY), className: 'reactgrid-cell' },
                        { type: "text", text: formatTemperature(temperature.tempZ), className: 'reactgrid-cell' },
                    ]
                }))
            ];

            setRows(createdRows);
        }
    }

    function formatTemperature(tempValue: any) {
        console.log("formatTemperature");
        console.log(tempValue);

        if (!tempValue)
            return "0.000";

        const temp = parseFloat(tempValue);

        console.log(temp);
        console.log(typeof(temp));

        if (!temp)
            return "0.000";

        return temp.toFixed(DECIMAL_PLACES).toString();
    }

    //render

    function getEditTypeTemplate(temperature: BpMpTemperature ) {
        switch (temperature.editType) {
            case EditType.None:
                return "";
            case EditType.Insert:
                return "reactgrid-add-icon";
            case EditType.Update:
                return "reactgrid-edit-icon";
            case EditType.Delete:
                return "reactgrid-delete-icon";
        }
    }

    function onSaveClick() {
        saveWeightData();
    }

    function onCloseClick() {
        const anyNonSavedChanges = temperatures.some(a => a.editType !== EditType.None);

        if (anyNonSavedChanges) {
            showPromptMessage(ModalMessageType.PromptYesNo, "Pending Changes Not Saved", "You have pending changes not yet saved. Do you want to close anyway?", PENDING_CHANGES);
        }
        else
            closeDialog();
    }

    async function closeDialog() {
        if (props.onClose)
            props.onClose();
    }
    
    async function saveWeightData() {
        if (!temperatures)
            return;

        let preparedTemperatures = [...temperatures];

        preparedTemperatures.forEach(t => {
            t.benchSheetId = props.benchSheetId;
        });

        console.log("preparedTemperatures...");
        console.log(preparedTemperatures);

        if (preparedTemperatures) {
            await updateTemperatures(preparedTemperatures)
                .then((data) => {
                    getTemperatures();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Temperatures");
                });
        }
    }

    async function updateTemperatures(updatedTemperatures: BpMpTemperature[]) {
        return await CrudFunctions.putData(`benchsheets/bpmptemperatures/${props.benchSheetId}`, updatedTemperatures);
    }

    // CRUD functions

    async function getTemperatures() {
        await CrudFunctions.getData(`benchsheets/bpmptemperatures/${props.benchSheetId}`)
            .then(data => {
                console.log("temperatures:");
                console.log(data);

                setTemperatures(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Temperatures");
            });
    }

    async function getAllData() {
        assembleGrid();

        if (props.benchSheetId) {
            await Promise.all([
                getTemperatures()
            ])
        }
    }

    function assembleGrid() {
        getInitColumns();
        getHeaderRow();
    }

    function getInitColumns() {
        let initColumns: Column[] = [];

        initColumns.push({ columnId: "temperatureId", width: -20 });
        initColumns.push({ columnId: EDIT_TYPE_COLUMN_ID, width: -20 });
        initColumns.push({ columnId: "sampleName", width: 100, resizable: true });
        initColumns.push({ columnId: "tempX", width: 90, resizable: true });
        initColumns.push({ columnId: "tempY", width: 90, resizable: true });
        initColumns.push({ columnId: "tempZ", width: 90, resizable: true });
        
        setColumns(initColumns);
    }

    function getHeaderRow() {
        let headerCells: DefaultCellTypes[] = [];

        headerCells.push({ type: "header", text: "", className: "reactgrid-hidden-column" });
        headerCells.push({ type: "header", text: "", className: "" });
        headerCells.push({ type: "header", text: "Sample Name", className: "reactgrid-header-cell" });
        
        headerCells.push({ type: "header", text: "X", className: "reactgrid-header-cell" });
        headerCells.push({ type: "header", text: "Y", className: "reactgrid-header-cell" });
        headerCells.push({ type: "header", text: "Z", className: "reactgrid-header-cell" });

        const initHeaderRow: Row = {
            rowId: "header",
            cells: headerCells
        };

        setHeaderRow(initHeaderRow);
    }

    function onGlobalDialogReply(reply: MessageBoxReply) {
        console.log("onGlobalDialogReply");
        console.log(reply);

        if (reply.code === PENDING_CHANGES) {
            if (reply.reply !== MessageBoxReplyType.Yes) {
                setGlobalDialogVisible(false);
            }
            else {
                closeDialog();
            }
        }
    }

    function onGlobalDialogClose() {
        clearGlobalDialog();
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function showPromptMessage(mode: ModalMessageType, title: string, message: string, code: number) {
        let mm: ModalMetadata = {
            error: null,
            mode: mode,
            title: title,
            message: message,
            code: code
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}
